module.exports = __webpack_public_path__ + "h5/img/user.a3bc0d92.png";